const rolesNames = {
  admin: 'Admin',
  explorer: 'Explorer',
  user: 'User',
};

export function getRoleName(role) {
  return rolesNames[role];
}